import axios from '../api' // 倒入 api


//获取分享车辆位置点信息
const getCarLocation = (key) => {
    return axios({
        url: `/api/plc/app/location/${key}`,
        method: 'GET',
    })
}

//获取分享行程列表（默认近20天数据）
const getTravelList = (key,params) => {
    return axios({
        url: `/api/plc/app/travel/${key}`,
        method: 'GET',
        params
    })
}

//获取分享车辆轨迹信息
const getTrackList = (key,params) => {
    return axios({
        url: `/api/plc/app/replay/list/${key}`,
        method: 'GET',
        params
    })
}

//获取停车点列表
const getParkPoints = (key,params) => {
    return axios({
        url: `/api/plc/app/replay/parking/${key}`,
        method: 'GET',
        params
    })
}

//获取报警点列表
const getAlarmPoints = (key,params) => {
    return axios({
        url: `/api/plc/app/replay/alarm/${key}`,
        method: 'GET',
        params
    })
}

//获取报警点列表
const getAddoilPoints = (key,params) => {
    return axios({
        url: `/api/plc/app/replay/addoil/${key}`,
        method: 'GET',
        params
    })
}

//获取漏油点列表
const getLeakPoints = (key,params) => {
    return axios({
        url: `/api/plc/app/replay/oilLeakage/${key}`,
        method: 'GET',
        params
    })
}

export default {
    getCarLocation,
    getTravelList,
    getTrackList,
    getParkPoints,
    getAlarmPoints,
    getAddoilPoints,
    getLeakPoints,
}